import { useMemo } from "react";
import MediaEntityMapModal from "./media-entity-modal/MediaEntityMapModal";
import NonGeoEntityModal from "./NonGeoEntityModal";
import SelectedEntityCardCornerModal from "./SelectedEntityCardCornerModal";
import { useSelectedEntity } from "../../hooks/useSelectedEntity";
import { usePopupSelector } from "../../store/popupStore";

export default function EntityMapModal() {
  const { entity, endpoint } = useSelectedEntity();
  const { popupType, isContentVisible, isFullViewerOpen } = usePopupSelector();
  const isSpatialDataset = endpoint?.entityType === "spatial-dataset";

  // Corner card position: shift further down when media-viewer is open
  // (media-viewer shows "Switch to Map" toggle which needs extra vertical clearance)
  const cornerCardSx = useMemo(
    () => ({
      top: popupType === "media-viewer" ? "7em" : "0.6em",
      right: popupType === "media-viewer" ? "1em" : "0.5em"
    }),
    [popupType]
  );

  // Nothing to show: no popup type set
  if (!popupType) return null;

  // geo-entity: the <MapPopup> inside MapComponent.tsx handles rendering; nothing to show here
  if (popupType === "geo-entity") return null;

  // Geotagged media: MapLibre Popup in MapComponent handles it unless full viewer is open.
  // Treat geometry as valid only when it is a non-empty, non-"EMPTY" WKT string or a
  // GeoJSON object — an "EMPTY" WKT (e.g. "POINT EMPTY") has no renderable coordinates.
  const hasRenderableGeometry = (() => {
    const g = entity?.geometry;
    if (!g) return false;
    if (typeof g === "string") return g.trim().length > 0 && !g.toUpperCase().includes("EMPTY");
    return true; // GeoJSON object
  })();
  if (popupType === "media-viewer" && hasRenderableGeometry && !isFullViewerOpen) return null;

  return (
    <>
      {/* Corner mini-card — spatial datasets always use the corner card (no full-screen modal);
          non-spatial: only when content is collapsed */}
      {(!isContentVisible || isSpatialDataset) && popupType !== "media-viewer" && <SelectedEntityCardCornerModal sx={cornerCardSx} />}

      {/* Primary popup — skip NonGeoEntityModal for spatial datasets (corner card handles them) */}
      {popupType === "non-geo-entity" && !isSpatialDataset && <NonGeoEntityModal />}
      {popupType === "media-viewer" && <MediaEntityMapModal />}
    </>
  );
}
